
import { createClient } from '@supabase/supabase-js';

/**
 * Configuration Supabase
 * Sur Vercel, configurez ces variables dans 'Project Settings' > 'Environment Variables'
 * Utilisez VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY pour une compatibilité Vite standard.
 */
// Fix: Cast import.meta to any to access the env property without TypeScript errors
const supabaseUrl = 
  ((import.meta as any).env?.VITE_SUPABASE_URL as string) || 
  (process.env.SUPABASE_URL as string) || 
  'https://lltsrtityvwsvhbkzdll.supabase.co';

// Fix: Cast import.meta to any to access the env property without TypeScript errors
const supabaseAnonKey = 
  ((import.meta as any).env?.VITE_SUPABASE_ANON_KEY as string) || 
  (process.env.SUPABASE_ANON_KEY as string) || 
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxsdHNydGl0eXZ3c3ZoYmt6ZGxsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg4MzYzNDQsImV4cCI6MjA4NDQxMjM0NH0.Vn25-DddYdl329ds9ur7nNA8nN4GXN1Cq9JvUkSXY1c';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
